(function () {
  function updateHeaderCartCount() {
    var countEls = document.querySelectorAll('[data-header-cart-count]');
    if (!countEls.length) return;

    countEls.forEach(function (el) {
      if (!/^\d+$/.test(el.textContent.trim())) {
        el.textContent = '0';
      }
    });

    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (response) {
        return response.ok ? response.json() : null;
      })
      .then(function (cart) {
        if (!cart || typeof cart.item_count !== 'number') return;
        countEls.forEach(function (el) {
          el.textContent = String(cart.item_count);
        });
      })
      .catch(function () {});
  }

  document.addEventListener('DOMContentLoaded', updateHeaderCartCount);
  window.addEventListener('pageshow', updateHeaderCartCount);
  setTimeout(updateHeaderCartCount, 1200);
  setTimeout(updateHeaderCartCount, 3000);
})();
